const controller = function (mbSidemenuService) {
	const vm = this;

	vm.openMenu = () => {
		mbSidemenuService.openMenu();
	};

	vm.$onInit = () => {
		if (vm.config.usersBirthday) {
			vm.config.usersBirthday.getUsers().then((response) => {
				vm.config.usersBirthday.users = response
			})
		}
	}

	vm.isOnline = () => {
		const onlineStatus = JSON.parse(localStorage.getItem('online-status'))
		return onlineStatus && onlineStatus.online
	}

	vm.changeStatusOnline = () => {
		const onlineStatus = JSON.parse(localStorage.getItem('online-status'))
		localStorage.setItem('online-status', JSON.stringify({change: true, online: !(onlineStatus && onlineStatus.online)}))
	}
};

export default controller;



// WEBPACK FOOTER //
// ./src/modules/topbar/controllers/topbar.controller.js